import React, { useMemo } from 'react';

import { Separator } from 'craft/components/SelectedToolbar';
import { FloatingMenuTabContext } from 'craft/containers/FloatingMenu';
import { TabContext } from 'craft/containers/FlowsFloatingMenu/FlowsFloatingMenu';
import { useFlow } from 'craft/state';

import { DeleteStepButton } from './DeleteStepButton';
import { DuplicateStepButton } from './DuplicateStepButton';
import { ReorderStepButton } from './ReorderStepButton';

interface Props {
  flowId: string;
  flowTabContext: TabContext;
  menuPosition: 'top' | 'bottom';
}

export const FlowStepTabContextMenu = ({ flowId, flowTabContext, menuPosition }: Props) => {
  const { stepIds } = useFlow(flowId);

  const tooltipPlacement = useMemo(() => (menuPosition === 'top' ? 'bottom' : 'top'), [
    menuPosition,
  ]);

  const { id, index, dom } = flowTabContext;

  const canDelete = stepIds.length > 1;
  const canMoveLeft = stepIds.length > 1 && index > 0;
  const canMoveRight = stepIds.length > 1 && index < stepIds.length - 1;

  return (
    <FloatingMenuTabContext dom={dom} menuPosition={menuPosition}>
      <DuplicateStepButton flowId={flowId} stepId={id} tooltipPlacement={tooltipPlacement} />
      <DeleteStepButton
        flowId={flowId}
        stepId={id}
        disabled={!canDelete}
        tooltipPlacement={tooltipPlacement}
      />
      <Separator />
      <ReorderStepButton
        flowId={flowId}
        index={index}
        direction="left"
        disabled={!canMoveLeft}
        tooltipPlacement={tooltipPlacement}
      />
      <ReorderStepButton
        flowId={flowId}
        index={index}
        direction="right"
        disabled={!canMoveRight}
        tooltipPlacement={tooltipPlacement}
      />
    </FloatingMenuTabContext>
  );
};
